export default __webpack_public_path__ + "static/media/image.20dd3508.svg";